<template>
    <master-page>
        <br/>
        <v-card>
            <v-card-title>
                <v-icon large left>mdi-account-multiple-check</v-icon>
                <span class="title font-weight-light">Frequência</span>
                <v-spacer/>
                <div style="margin-top: 10px">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon color="primary" class="mb-2" dark v-on="on" @click="Salvar()">
                                <v-icon>mdi-content-save</v-icon>
                            </v-btn>
                        </template>
                        <span>Salvar</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon color="primary" class="mb-2" dark v-on="on" @click="Limpar()">
                                <v-icon>mdi-eraser</v-icon>
                            </v-btn>
                        </template>
                        <span>Limpar</span>
                    </v-tooltip>
                </div>
                <info/>
            </v-card-title>

            <v-card-text>
                
                <v-form id="formCadastroFrequencia" ref="formCadastroFrequencia" v-model="valid" lazy-validation >
                    <v-row>
                        <v-col cols="12" md="8">
                          <v-autocomplete v-model="item.projetoId" :items="projetos" :loading="isProjetoLoading" :search-input.sync="searchProjeto" hide-no-data hide-selected clearable
                              item-text="codigoNome" item-value="id" label="Projeto" placeholder="Digite um projeto"  :rules="fieldRules" @change="Obter()" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="item.data" label="Data" :rules="fieldRules" dense outlined @blur="Obter()">
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="item.data" no-title @change="Obter()"/>
                            </v-menu>
                        </v-col>
                    </v-row>

                    <div class="cards-totalizadores-container mb-4">
                        <v-card v-for="card in cardsTotalizadores" :key="card.chave" class="pa-3 totalizador-card" outlined :style="`background-color: ${card.corFundo}; border-color: ${card.corBorda};`">
                            <div class="d-flex">
                                <v-avatar size="28" :color="card.corIconeFundo" class="mr-3">
                                    <v-icon small :color="card.corIcone">{{ card.icone }}</v-icon>
                                </v-avatar>
                                <div>
                                    <div class="totalizador-titulo">{{ card.titulo }}</div>
                                    <div class="totalizador-valor">{{ card.valor }}</div>
                                    <div class="totalizador-subtitulo">{{ card.subtitulo }}</div>
                                </div>
                            </div>
                        </v-card>
                    </div>

                    <v-data-table id="tabela" :headers="headers" :items="lista" sort-by="beneficiarioNome" :items-per-page="-1" :loading="loading" class="elevation-1" hide-default-footer>
            
                        <template v-slot:[`item.actions`]="{ item }">

                            <v-tooltip right>
                                <template v-slot:activator="{ on }">
                                    <v-icon small @click="MudaSituacao(item)" v-on="on">mdi-arrow-right</v-icon>
                                </template>
                                <span>Falta</span>
                            </v-tooltip>

                        </template>

                        <template v-slot:[`item.beneficiario.nome`]="{ item }">
                            {{item.beneficiarioNome}}
                        </template>

                        <template v-slot:[`item.situacao.nome`]="{ item }">
                            <v-chip
                                small
                                class="situacao-chip"
                                :style="`background-color: ${GetSituacaoChip(item).corFundo}; border-color: ${GetSituacaoChip(item).corBorda}; color: ${GetSituacaoChip(item).corTexto};`"
                                style="border-width: 1px; border-style: solid; font-weight: 600;"
                            >
                                {{ GetSituacaoChip(item).texto }}
                            </v-chip>
                        </template>

                        <template v-slot:[`item.observacao`]="{ item }">
                            <v-text-field v-model="item.observacao" :counter="255" maxlength="255"/>
                        </template>

                    </v-data-table>

                    <!-- <v-data-table :headers="headers" :items="lista" :loading="loading" :items-per-page="-1" :hide-default-footer="true" class="elevation-1">
                        <template v-slot:body="{ items }">
                        <tbody>
                            <tr v-for="item in items" :key="item.id">
                                <td class="justify-center pl-4 px-0">
                                    <v-tooltip right>
                                        <template v-slot:activator="{ on }">
                                        <v-icon small @click="MudaSituacao(item)" v-on="on">mdi-arrow-right</v-icon>
                                        </template>
                                        <span>Falta</span>
                                    </v-tooltip>
                                </td>
                                <td>{{ item.beneficiarioNome }}</td>
                                <td>{{ item.situacaoStr }}</td>
                                <td> <v-text-field v-model="item.observacao"/> </td>
                            </tr>
                        </tbody>
                        </template>
                    </v-data-table> -->

                </v-form>

            </v-card-text>
        </v-card>

        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </master-page>

</template>
<script>
import FrequenciaService from '@/core/services/projetos/FrequenciaService';
import Frequencia from '@/core/domain/projetos/Frequencia';
import ProjetoService from '@/core/services/projetos/ProjetoService';

export default {

    watch: { 
        item: function() { 
            if ('formCadastroFrequencia' in this.$refs)
                this.$refs.formCadastroFrequencia.resetValidation();
        },
        value: function() {
            this.dialog = this.value;
        },
        dialog: function() {
            if (!this.dialog) {
                this.$emit('fechou');
            }
        },
        searchProjeto (val) {
            if (this.item.projetoId) return;
            if (this.isProjetoLoading) return;
            if (!val) return;
            
            this.isProjetoLoading = true
            const projetoService = new ProjetoService();
            projetoService.AutoComplete(val)
                .then(
                    res => {
                        this.projetos = res.data;
                    },
                    err => this.$swal('Aviso', err.response.data, 'error')
                )
                .finally(() => (this.isProjetoLoading = false))
        }
    },
    data: () => ({
        item: new Frequencia(),
        service: new FrequenciaService(),
        valid: true,
        dialog: false,
        loading: false,
        isProjetoLoading: false,
        projetos: [],
        lista: [],
        searchProjeto: null,
        headers: [
            { text: '', value:'actions', sortable: false  },
            { text: 'Benefiário', value: 'beneficiario.nome', sortable: false },
            { text: 'Situação', value: 'situacao.nome', sortable: false },
            { text: 'Observações', value: 'observacao', sortable: false },
        ],
        fieldRules: [
            v => !!v || 'Campo obrigatório'
        ],
        sessionApp: {},
    }),
    computed: {
        totalBeneficiario(){
            return this.lista.length;
        },
        totalPresenca(){
            return this.lista.filter(x => this.NormalizarSituacao(x.situacao) === 'P').length;
        },
        totalFaltas(){
            return this.lista.filter(x => this.NormalizarSituacao(x.situacao) === 'F').length;
        },
        totalVazios(){
            return this.lista.filter(x => this.NormalizarSituacao(x.situacao) === 'V').length;
        },
        cardsTotalizadores(){
            return [
                {
                    chave: 'total-beneficiario',
                    titulo: 'Total beneficiário',
                    valor: this.totalBeneficiario,
                    subtitulo: 'Registros carregados na lista',
                    icone: 'mdi-account-group',
                    corFundo: '#edf2f7',
                    corBorda: '#d4dde8',
                    corIconeFundo: '#dfe7f1',
                    corIcone: '#3f5d7a'
                },
                {
                    chave: 'total-presenca',
                    titulo: 'Total presença',
                    valor: this.totalPresenca,
                    subtitulo: '',
                    icone: 'mdi-check-circle-outline',
                    corFundo: '#eaf6ef',
                    corBorda: '#d3e8dc',
                    corIconeFundo: '#dceddf',
                    corIcone: '#2f6f4f'
                },
                {
                    chave: 'total-faltas',
                    titulo: 'Total faltas',
                    valor: this.totalFaltas,
                    subtitulo: '',
                    icone: 'mdi-close-circle-outline',
                    corFundo: '#fff5e9',
                    corBorda: '#f0dfc8',
                    corIconeFundo: '#f8e9d4',
                    corIcone: '#8a5a21'
                },
                {
                    chave: 'total-vazios',
                    titulo: 'Total vazios',
                    valor: this.totalVazios,
                    subtitulo: '',
                    icone: 'mdi-checkbox-blank-circle-outline',
                    corFundo: '#f1eef9',
                    corBorda: '#ddd6ee',
                    corIconeFundo: '#e7e1f4',
                    corIcone: '#5d4c8c'
                }
            ];
        }
    },
    methods: {
        NormalizarSituacao(situacao){
            const situacaoNormalizada = (situacao || 'P').toString().trim().toUpperCase();
            return ['P', 'F', 'V'].includes(situacaoNormalizada) ? situacaoNormalizada : 'P';
        },
        GetSituacaoChip(item){
            const situacao = this.NormalizarSituacao(item && item.situacao);

            if (situacao === 'F'){
                return {
                    texto: 'Falta',
                    corFundo: '#fff5e9',
                    corBorda: '#f0dfc8',
                    corTexto: '#8a5a21'
                };
            }

            if (situacao === 'V'){
                return {
                    texto: 'Vazio',
                    corFundo: '#f1eef9',
                    corBorda: '#ddd6ee',
                    corTexto: '#5d4c8c'
                };
            }

            return {
                texto: 'Presença',
                corFundo: '#eaf6ef',
                corBorda: '#d3e8dc',
                corTexto: '#2f6f4f'
            };
        },
        Obter(){

            if (!this.item.projetoId || !this.item.data){
                this.lista = [];
                return;
            }

            this.service.Obter(this.item.projetoId, this.item.data).then( 
                res => this.lista = res.data
            )
        },
        MudaSituacao(item){
            switch (item.situacao) {
                case 'P':
                    item.situacao = 'F';
                    item.situacaoStr = 'Falta';
                    break;
                case 'F':
                    item.situacao = 'V';
                    item.situacaoStr = 'Vazio';
                    break;
                default:
                    item.situacao = 'P';
                    item.situacaoStr = 'Presença';
                    break;
            }
        },
        Salvar() {

            if (this.$refs.formCadastroFrequencia.validate()) {
                this.loading = true;
                let frequencias = [];
                this.lista.forEach(frequencia => {
                    frequencia = new Frequencia(frequencia);
                    frequencias.push(frequencia);
                });

                this.service.SalvarLista(frequencias).then(
                    res => {
                        this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                        this.Limpar();
                    }, 
                    err => this.$swal('Aviso', err.response.data, 'error')
                ).finally(() => {
                    this.loading = false;
                });
            }

        },
        Limpar() {
            this.item = new Frequencia();
            this.lista = [];
        }
    },
    beforeUpdate(){
        if (!this.dialog){
            this.$emit('fechou');
        }
    },
    mounted() {

    }
}
</script>
<style scoped>
.totalizador-card {
    border-width: 1px;
    border-style: solid;
    min-height: 100px;
    width: 100%;
}

.cards-totalizadores-container {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: clamp(8px, 0.8vw, 14px);
}

@media (max-width: 1400px) {
    .cards-totalizadores-container {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 700px) {
    .cards-totalizadores-container {
        grid-template-columns: repeat(1, minmax(0, 1fr));
    }
}

.totalizador-titulo {
    font-size: 12px;
    color: #5f6a77;
    font-weight: 600;
    line-height: 1.3;
}

.totalizador-valor {
    font-size: 30px;
    font-weight: 700;
    color: #202b37;
    line-height: 1.1;
}

.totalizador-subtitulo {
    font-size: 12px;
    color: #6b7280;
    margin-top: 2px;
}

.situacao-chip {
    min-width: 92px;
    height: 24px;
    justify-content: center;
    text-align: center;
}

.situacao-chip::v-deep .v-chip__content {
    width: 100%;
    justify-content: center;
}
</style>
